/**
 * Body editor for the append step: parent container (slot or typed name)
 * plus the drop zone for the children to nest under it.
 */
import React from "react"
import { Tooltip } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons"
import { BuilderDropZone } from "shared/ui/Builder"
import { QueryBuilderStore } from "stores/queryBuilderStore"
import { AppendStep } from "types/queryBuilder.types"
import SingleFieldSlot from "../SingleFieldSlot.component"
import { StepBodyProps } from "./stepBodyProps"

export interface AppendStepBodyProps extends StepBodyProps<AppendStep> {
  setAppendParent: QueryBuilderStore["setAppendParent"]
  onAddSource: (variable: string) => void
  onRemoveSource: (variable: string) => void
}

const AppendStepBody: React.FC<AppendStepBodyProps> = ({
  step,
  setAppendParent,
  onAddSource,
  onRemoveSource,
}) => (
  <>
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">
        Parent container:
        <Tooltip
          title="The QTable that will receive these children. Created automatically if it doesn't exist yet; APPEND auto-promotes a non-existent target to a container."
          placement="top"
          overlayClassName="dataq-tooltip"
        >
          <FontAwesomeIcon
            icon={faCircleInfo}
            className="qc-step__field-info"
          />
        </Tooltip>
      </span>
      <SingleFieldSlot
        value={step.parent}
        onChange={(v) => setAppendParent(step.id, v)}
        placeholder="Drag the parent container, or type a name"
      />
    </div>
    <input
      className="qc-recodes__name qc-mono"
      type="text"
      value={step.parent}
      onChange={(e) => setAppendParent(step.id, e.target.value)}
      placeholder="…or type a parent container name"
      aria-label="Parent container name"
    />
    <BuilderDropZone
      label="Fields or containers to append"
      variables={step.children}
      onAdd={onAddSource}
      onRemove={onRemoveSource}
      emptyHint="Drag fields or sub-containers to nest under this container"
    />
  </>
)

export default AppendStepBody
